function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.09091 3V3.78261H3V21H20V3.78261H16.9091V3H15.3636V3.78261H7.63636V3H6.09091ZM4.54545 5.34783H6.09091V6.13043H7.63636V5.34783H15.3636V6.13043H16.9091V5.34783H18.4545V6.91304H4.54545V5.34783ZM4.54545 8.47826H18.4545V19.4348H4.54545V8.47826ZM9.18182 10.0435V11.6087H10.7273V10.0435H9.18182ZM12.2727 10.0435V11.6087H13.8182V10.0435H12.2727ZM15.3636 10.0435V11.6087H16.9091V10.0435H15.3636ZM6.09091 13.1739V14.7391H7.63636V13.1739H6.09091ZM9.18182 13.1739V14.7391H10.7273V13.1739H9.18182ZM12.2727 13.1739V14.7391H13.8182V13.1739H12.2727ZM15.3636 13.1739V14.7391H16.9091V13.1739H15.3636ZM6.09091 16.3043V17.8696H7.63636V16.3043H6.09091ZM9.18182 16.3043V17.8696H10.7273V16.3043H9.18182ZM12.2727 16.3043V17.8696H13.8182V16.3043H12.2727Z",
  fill: "#7A7A7A"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0b25ae76.svg";
export { ForwardRef as ReactComponent };